import { blue, grey } from "@mui/material/colors";

const styles = {
  metricsWrapper: {
    py: 1,
  },
  header: {
    color: "primary.main",
    fontWeight: 600,
    fontSize: 12,
    textTransform: "uppercase",
    pl: 2,
  },
  annotation: {
    color: grey[500],
    fontSize: 10,
  },
  lastUsed: {
    fontSize: 8,
    color: "black",
    backgroundColor: blue[50],
  },
  topPerforming: {
    color: "success.main",
    fontSize: 8,
    fontWeight: 600,
  },
};

export default styles;
